import { JiraLogo } from '@atlaskit/logo';

import { EnterpriseLogo } from '@/libraries/wpl/foundations/src/logos/enterprise-logo.tsx';

import { AtlasMarkBrand } from './logos/atlas-mark-brand';
import { AtlassianLogoBrand } from './logos/atlassian-logo-brand';
import { AtlassianLogoNeutral } from './logos/atlassian-logo-neutral';
import { BitbucketMarkBrand } from './logos/bitbucket-mark-brand';
import { CompassMarkBrand } from './logos/compass-mark-brand';
import { ConfluenceLogoBrand } from './logos/confluence-logo-brand';
import { ConfluenceMarkBrand } from './logos/confluence-mark-brand';
import { CustomerServiceManagementLogoBrand } from './logos/customerservicemanagement-logo-brand';
import { CustomerServiceManagementMarkBrand } from './logos/customerservicemanagement-mark-brand';
import { HalpLogoBrand } from './logos/halp-logo-brand';
import { JiraMarkBrand } from './logos/jira-mark-brand';
import { JiraAlignMarkBrand } from './logos/jiraalign-mark-brand';
import { JiraProductDiscoveryLogoBrand } from './logos/jiraproductdiscovery-logo-brand';
import { JiraProductDiscoveryMarkBrand } from './logos/jiraproductdiscovery-mark-brand';
import { JiraServiceManagementLogoBrand } from './logos/jiraservicemanagement-logo-brand';
import { JiraServiceManagementMarkBrand } from './logos/jiraservicemanagement-mark-brand';
import { JiraSoftwareLogoBrand } from './logos/jirasoftware-logo-brand';
import { JiraSoftwareMarkBrand } from './logos/jirasoftware-mark-brand';
import { JiraWorkManagementMarkBrand } from './logos/jiraworkmanagement-mark-brand';
import { TrelloMarkBrand } from './logos/trello-mark-brand';

export type LogoBrand =
	| 'atlas'
	| 'atlassian'
	| 'bitbucket'
	| 'compass'
	| 'confluence'
	| 'customerservicemanagement'
	| 'enterprise'
	| 'halp'
	| 'jira'
	| 'jiraalign'
	| 'jiraproductdiscovery'
	| 'jiraservicemanagement'
	| 'jirasoftware'
	| 'jiraworkmanagement'
	| 'softwaredevelopment'
	| 'trello';

export interface LogoProps {
	type: 'logo' | 'mark';
	appearance: 'brand' | 'inverse' | 'neutral';
	brand: LogoBrand;
}

type LogoAppearance = {
	brand: JSX.Element;
	inverse?: JSX.Element;
	neutral?: JSX.Element;
};

type LogoType = {
	mark?: LogoAppearance;
	logo?: LogoAppearance;
};

type Logos = { [key in LogoBrand]: LogoType };

const Logos: Logos = {
	atlas: {
		mark: {
			brand: <AtlasMarkBrand />,
		},
	},
	atlassian: {
		logo: {
			brand: <AtlassianLogoBrand />,
			neutral: <AtlassianLogoNeutral />,
		},
	},
	bitbucket: {
		mark: {
			brand: <BitbucketMarkBrand />,
		},
	},
	compass: {
		mark: {
			brand: <CompassMarkBrand />,
		},
	},
	confluence: {
		logo: {
			brand: <ConfluenceLogoBrand />,
		},
		mark: {
			brand: <ConfluenceMarkBrand />,
		},
	},
	customerservicemanagement: {
		logo: {
			brand: <CustomerServiceManagementLogoBrand />,
		},
		mark: {
			brand: <CustomerServiceManagementMarkBrand />,
		},
	},
	enterprise: {
		logo: {
			brand: <EnterpriseLogo />,
		},
	},
	halp: {
		logo: {
			brand: <HalpLogoBrand />,
		},
	},
	jira: {
		logo: {
			brand: <JiraLogo appearance="brand" />,
		},
		mark: {
			brand: <JiraMarkBrand />,
		},
	},
	jiraalign: {
		mark: {
			brand: <JiraAlignMarkBrand />,
		},
	},
	jiraservicemanagement: {
		logo: {
			brand: <JiraServiceManagementLogoBrand />,
		},
		mark: {
			brand: <JiraServiceManagementMarkBrand />,
		},
	},
	jiraproductdiscovery: {
		logo: {
			brand: <JiraProductDiscoveryLogoBrand />,
		},
		mark: {
			brand: <JiraProductDiscoveryMarkBrand />,
		},
	},
	jirasoftware: {
		logo: {
			brand: <JiraSoftwareLogoBrand />,
		},
		mark: {
			brand: <JiraSoftwareMarkBrand />,
		},
	},
	jiraworkmanagement: {
		mark: {
			brand: <JiraWorkManagementMarkBrand />,
		},
	},
	softwaredevelopment: {},
	trello: {
		mark: {
			brand: <TrelloMarkBrand />,
		},
	},
};

export const Logo = ({ brand, type, appearance }: LogoProps) => {
	return Logos[brand]?.[type]?.[appearance];
};
